module.exports = __webpack_public_path__ + "static/media/ISO20560.b1aa06b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/normes/ISO20560.svg
// module id = 71
// module chunks = 0